import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFBlueArrowUpSmall from '@/components/UI/svg/Icons/EFBlueArrowUpSmall';
import { createEFPic } from '@/utils/useEFPic';
import { saveAICookieForShopify } from '@elem/ui-common/utils/CookieForShopify';

const { EFPic } = createEFPic('/media/deltapro/h5/');
export default function Tail() {
    const { Link, useLang, useRouter, gtm } = useGlobal();
    const { t } = useLang('delta_pro_new');
    const { t: s } = useLang('shared');
    const { locale } = useRouter();

    const items1 = [
        {
            id: 1,
            bgImage: [`09DeltaProExtraBattery.webp`, `09DeltaProExtraBattery.png`],
            desc: t('delta_pro_extra_battery'),
            link:
                locale === 'cn'
                    ? 'https://item.jd.com/10050023721649.html#none'
                    : locale === 'cis'
                    ? 'https://ecoflow-russia.com/products/vneshnyaya-umnaya-batareya-dlya-stantsij-ecoflow-delta-pro'
                    : locale === 'sa'
                    ? 'https://www.amazon.ae/dp/B0B45XT3RW?ref=myi_title_dp'
                    : `https://${locale}.ecoflow.com/products/delta-pro-smart-extra-battery`,
        },
    ];

    if (!['cn', 'cis', 'ph'].includes(locale)) {
        items1.push({
            id: 2,
            bgImage: [`09SmartGenerator.webp`, `09SmartGenerator.png`],
            desc: t('smart_generator'),
            link: ['us', 'ca'].includes(locale) ? '/dual-fuel-smart-generator' : ['br', 'mx'].includes(locale) ? '' : '/smart-generator',
        });
    }

    const handleLinkClick = (item: any) => {
        saveAICookieForShopify(item?.link, locale);

        gtm.push({
            event: 'uaEvent',
            event_name: 'buy',
            product_name: 'EcoFlow DELTA Pro',
            position: 'In-Product Details Page',
            __btn_id1: css.tailA,
            __btn_id2: item.link,
        });
    };

    return (
        <div className={`${css.tailA} tailA2 GtmModuleData-section`} data-section-id={css.tailA} data-section-title={t('extra_battery_port')}>
            <div className="product-card-list">
                {items1.map((item: any) => (
                    <div className="product-card" key={item.id}>
                        <div className="card-img" style={{ height: '1.5rem' }}>
                            <EFPic name={item.bgImage} alt={item.desc}></EFPic>
                        </div>
                        <div className="card-title">{item.desc}</div>
                        {item?.link && (
                            <div className="card-link">
                                <Link
                                    className="GtmModuleData-btn-href"
                                    href={item.link}
                                    ariaLabel={item.desc}
                                    // dataLayer={{
                                    //     event: 'uaEvent',
                                    //     event_name: 'buy',
                                    //     product_name: 'EcoFlow DELTA Pro',
                                    //     position: 'In-Product Details Page',
                                    // }}
                                    onClick={() => handleLinkClick(item)}
                                >
                                    {s('support.site_support_learn_more')}
                                    <span className="card-icon">
                                        <EFBlueArrowUpSmall />
                                    </span>
                                </Link>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
